export interface Product {
  id: string;
  name: string;
  slogan: string;
  highlights: string[];
  category: 'strategic' | 'foundation' | 'marketing' | 'fishery';
  icon: string;
  url?: string;
  wechatTip?: string;
}

export const products: Product[] = [
  {
    id: 'auaa',
    name: '陆渔·确定性农业引擎',
    slogan: '陪你开启确定性农业之旅',
    highlights: ['第二大脑Agent', '项目落地指南', '行业智库', '渔王百宝箱', '生态集市', 'AUAA联盟'],
    category: 'strategic',
    icon: 'ri-rocket-2-line',
    url: 'https://auaa.luyuaqua.com',
  },
  {
    id: 'second-brain',
    name: '第二大脑',
    slogan: 'Where Knowledge Comes to You',
    highlights: ['认知中枢', '决策引擎', '权威发布', '品牌运营', '销售罗盘', 'Second Brain AI'],
    category: 'foundation',
    icon: 'ri-brain-line',
    url: 'https://secondbrain.luyuaqua.com',
  },
  {
    id: 'leo',
    name: 'LEO工作站',
    slogan: '让每一份工作都拥有AI的加速度',
    highlights: ['AI问答', '知识库管理', '智能体管理', '最全最强大模型', '数字员工'],
    category: 'foundation',
    icon: 'ri-robot-2-line',
    url: 'https://weknora.luyuaqua.com',
  },
  {
    id: 'traffic',
    name: '流量驱动系统',
    slogan: '用算法撬动流量自然增长',
    highlights: ['爆款视频解析', '二次改写', '热启动评论生成', '抖音热启动', '任务驱动'],
    category: 'foundation',
    icon: 'ri-line-chart-line',
    url: 'http://ai-web.luyuaqua.com',
  },
  {
    id: 'official',
    name: '陆渔科技官网',
    slogan: '确定性农业开创者',
    highlights: ['企业愿景', '科技引领', '绿色发展', '智领渔业未来', '一站式解决方案'],
    category: 'marketing',
    icon: 'ri-global-line',
    url: 'https://luyuaqua.com',
  },
  {
    id: 'guiyu',
    name: '鳜鱼启航引擎',
    slogan: '陆渔科技确定性农业的商业化落地样本',
    highlights: ['鳜鱼启航计划', '五重保障', '养殖方案', '案例介绍', '工具及产品中心'],
    category: 'marketing',
    icon: 'ri-ship-line',
    wechatTip: '微信小程序',
  },
  {
    id: 'customer-service',
    name: '智能客服',
    slogan: 'AI驱动的全链路客户转化引擎',
    highlights: ['意图识别', '回应话术', '内容推荐', '留资跳转', '销售线索捕捉'],
    category: 'marketing',
    icon: 'ri-customer-service-2-line',
    url: 'https://csa.luyuaqua.com',
  },
  {
    id: 'salesmind',
    name: 'SalesMind',
    slogan: 'Your deal, already known',
    highlights: ['成交潜力画像', '统计视图', '客户池管理', '公海池管理', 'AI参谋'],
    category: 'marketing',
    icon: 'ri-mind-map',
    url: 'https://salesmind.luyuaqua.com',
  },
  {
    id: 'yuce',
    name: '渔策',
    slogan: '验证你的RAS设想',
    highlights: ['养殖规划', '养殖目标', '投资预算', '可视化方案', '养殖挑战分析'],
    category: 'fishery',
    icon: 'ri-file-chart-line',
    url: 'http://yuce.luyuaqua.com',
  },
  {
    id: 'fishview',
    name: '渔全览',
    slogan: '你的每日养殖全景报告',
    highlights: ['数据采集', '智能分析', '策略输出', '水质监测', '生长追踪', 'AI决策模型'],
    category: 'fishery',
    icon: 'ri-dashboard-line',
    url: 'http://fishview.luyuaqua.com',
  },
  {
    id: 'vivian',
    name: '渔维',
    slogan: '设备维护工单全链路跟踪处理',
    highlights: ['快捷提单', '合理派发', 'AI识别', '自动派单', '运维指引', '问题定位'],
    category: 'fishery',
    icon: 'ri-tools-line',
    url: 'http://vivian.luyuaqua.com',
  },
  {
    id: 'water-monitor',
    name: '水质监测系统',
    slogan: '智慧养殖数字化平台',
    highlights: ['项目概览', '生产养殖', '远程监管', '实时监测', '多端访问'],
    category: 'fishery',
    icon: 'ri-water-percent-line',
    url: 'http://129.204.149.109:5001/?base=%E5%AE%89%E5%BE%BD%E5%AE%89%E5%BA%86%E5%9F%BA%E5%9C%B0',
  },
  {
    id: 'aic',
    name: 'AIC智能控制系统',
    slogan: '你的超级老师傅,决策不再凭感觉',
    highlights: ['养殖规划', '任务管理', '设备管控', 'AI分析', '风险预警', '策略推送'],
    category: 'fishery',
    icon: 'ri-settings-3-line',
    url: 'https://voyage.luyuaqua.com',
  },
  {
    id: 'pdm',
    name: 'PdM泵组预测性维护系统',
    slogan: '守住系统真正的"生命线"',
    highlights: ['振动监测', '温度监测', '提前预警', '故障预测', '保障稳定'],
    category: 'fishery',
    icon: 'ri-pulse-line',
  },
];
